// extracted by mini-css-extract-plugin
export default {"gradientBackground":"rtQ8efZeLqVQCwhu2s1Q","gradient":"PpJKdq_LqOkbqmJD3_n_"};